
export interface ClonedLineMapping {

  cloneLineId: number;
  cloneLineName: string;
  clonePlantId: number;
  clonePlantName: string;
  cloneCompanyId: number;
  cloneCompanyName: string;
  cloneRoomId: number;
  cloneRoomName: string;

  originalLineId: number;
  originalLineName: string;
  originalPlantId: number;
  originalPlantName: string;
  originalCompanyId: number;
  originalCompanyName: string;
  originalRoomId: number;
  originalRoomName: string;

  // These fields are aliases for real data from above. These aliases are here to be backward compatible with old
  // Drupal data.
  realLineId: number;
  realLineName: string;
  realPlantId: number;
  realPlantName: string;
  realCompanyId: number;
  realCompanyName: string;
  realClientId: number;
  realClientName: string;
  realRoomId: number;
  realRoomName: string;
  cloneClientId: number;
  cloneClientName: string;
}

export class ClonedLineMappingHelper {

  static populateAliases(__this: ClonedLineMapping) {
    __this.realLineId = __this.originalLineId;
    __this.realLineName = __this.originalLineName;
    __this.realPlantId = __this.originalPlantId;
    __this.realPlantName = __this.originalPlantName;
    __this.realCompanyId = __this.originalCompanyId;
    __this.realCompanyName = __this.originalCompanyName;
    __this.realClientId = __this.originalCompanyId;
    __this.realClientName = __this.originalCompanyName;
    __this.realRoomId = __this.originalRoomId;
    __this.realRoomName = __this.originalRoomName;
    __this.cloneClientId = __this.cloneCompanyId;
    __this.cloneClientName = __this.cloneCompanyName;
  }
}
